import { useAtom } from '@reatom/npm-react'
import { useAction } from '@reatom/npm-react'
import React from 'react'

import { pairFocusEvent } from '@root/entities/pair'
import { WalletAssetsCurrencyCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-asset-currency-cell'

import type { WalletAssetModel } from '@root/entities/wallet'

type Props = {
  asset: WalletAssetModel
}

export const WalletAssetsTableCurrencyCell: React.FC<Props> = ({ asset }) => {
  const [trend] = useAtom(asset.trend)
  const openPair = useAction(pairFocusEvent)

  const { pairAddress } = asset
  const handleClick = pairAddress
    ? (e: React.MouseEvent) => {
        e.stopPropagation()
        openPair({ network: asset.network, address: pairAddress })
      }
    : undefined

  return (
    <WalletAssetsCurrencyCell
      currency={asset.currency}
      pairAddress={asset.pairAddress}
      trend={trend}
      onClick={handleClick}
    />
  )
}
